/** OIDC / session claim keys that must never be forwarded to third-party analytics. */
const SENSITIVE_IDENTIFY_TRAIT_KEYS = new Set([
  'magentoToken',
  'access_token',
  'refresh_token',
  'id_token',
  'idToken'
]);

/**
 * Returns OIDC claims safe to send as Ninetailed identify traits.
 * Auth tokens and other session secrets are stripped.
 */
export function pickNinetailedIdentifyTraits(
  claims: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(claims).filter(
      ([key]: [string, unknown]) => !SENSITIVE_IDENTIFY_TRAIT_KEYS.has(key)
    )
  );
}
